import axios from 'src/utils/axios';

export default function v2_actionEditarLista(listaId, data) {
    return axios.put(`/api/v2/cadastro/contatos/listas/${listaId}/editar`, data);
}
